export * from './MailArrowInIcon';
export * from './MailArrowInIcon16Light';
export * from './MailArrowInIcon16Regular';
export * from './MailArrowInIcon16Solid';
export * from './MailArrowInIcon20Light';
export * from './MailArrowInIcon20Regular';
export * from './MailArrowInIcon20Solid';
export * from './MailArrowInIcon24Regular';
export * from './MailArrowInIcon24Solid';
export * from './MailArrowInIcon32Regular';
export * from './MailArrowInIcon64Regular';
